// @flow
import type {Action} from '../../../state/types'

export type SetDistrictsPayload = {
  districts: District[]
}

const id = 'hospital/SET_DISTRICTS'

export const setDistricts = (districts: District[]): Action<SetDistrictsPayload> => ({
  type: id,
  payload: {
    districts,
  }
})

setDistricts.id = id
